import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { form, FormField, validateStandardSchema } from '@angular/forms/signals';

import { RouterModule } from '@angular/router';

// local
import { FormErrorWrapper, FormLabel, PasswordInput } from '@aurrica-web/ui';
import { injectDispatch } from '@ngrx/signals/events';
import {
  ChangePassword,
  ChangePasswordSchema,
  authEvents,
} from '@aurrica-web/core-data';

@Component({
  selector: 'lib-auth-change-password-form',
  imports: [
    CommonModule,
    RouterModule,
    FormField,
    FormLabel,
    FormErrorWrapper,
    PasswordInput,
  ],
  template: `
    <form
      (submit)="onSubmit($event)"
      autocomplete="off"
      novalidate
      class="p-4 grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1 items-start"
    >
      <div class="flex flex-col gap-0.5 col-span-1 sm:col-span-2">
        <lib-ui-form-error
          [form]="changePasswordForm"
          ctrlName="current_password"
          #cpPassError="formError"
        >
          <lib-ui-form-label label="Current Password" />
        </lib-ui-form-error>
        <lib-ui-password-input
          [formField]="changePasswordForm.current_password"
        />
      </div>
      <div class="flex flex-col gap-0.5 col-span-1 sm:col-span-2">
        <lib-ui-form-error
          [form]="changePasswordForm"
          ctrlName="new_password"
          #newPassError="formError"
        >
          <lib-ui-form-label label="Password" />
        </lib-ui-form-error>
        <lib-ui-password-input
          [formField]="changePasswordForm.new_password"
        />
      </div>

      <div class="flex flex-col gap-0.5 col-span-1 sm:col-span-2">
        <lib-ui-form-error
          [form]="changePasswordForm"
          ctrlName="confirm_password"
          #confirmPassError="formError"
        >
          <lib-ui-form-label label="Confirm Password" />
        </lib-ui-form-error>
        <lib-ui-password-input [formField]="changePasswordForm.confirm_password" />
      </div>

      <!-- Submit Button -->
      <div
        class="flex flex-row justify-center gap-2 col-span-1 sm:col-span-2 mt-4"
      >
        <button
          type="submit"
          class="text-sm px-4 py-1 rounded-md
            bg-slate-950 text-white
            dark:bg-white dark:text-slate-950
            hover:bg-slate-800 dark:hover:bg-slate-200
            "
          [disabled]="changePasswordForm().invalid()"
        >
          Reset
        </button>
      </div>
    </form>
  `,
})
export class ChangePasswordForm {
  readonly authDispatch = injectDispatch(authEvents);

  changePasswordModel = signal<ChangePassword>({
    current_password: '',
    new_password: '',
    confirm_password: '',
  });
  changePasswordForm = form(this.changePasswordModel, (schemaPath) =>
    validateStandardSchema(schemaPath, ChangePasswordSchema),
  );

  onSubmit(event?: Event) {
    event?.preventDefault();
    if (!this.changePasswordForm().valid()) {
      this.changePasswordForm.current_password().markAsTouched();
      this.changePasswordForm.new_password().markAsTouched();
      this.changePasswordForm.confirm_password().markAsTouched();
      return;
    }
    const value = this.changePasswordForm().value();
    this.authDispatch.changePassword({
      currentPassword: value.current_password ?? '',
      newPassword: value.new_password ?? '',
    });
  }
}
